var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timeout" },
    [
      _c("div", { staticClass: "timeout__header" }, [
        _vm._v(_vm._s(_vm.$t("Account.Timeout")))
      ]),
      _vm._v(" "),
      _vm.processing
        ? _c(
            "div",
            { staticClass: "timeout__spinner" },
            [
              _c("v-progress-circular", {
                staticClass: "redirecting-circular-progress",
                attrs: { indeterminate: "" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.processing
        ? _c("div", { staticClass: "timeout__body" }, [
            _c("div", { staticClass: "timeout__info" }, [
              _c("div", [_vm._v(_vm._s(_vm.$t("Account.Timeout.Desc.One")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "acc_infomsg_accent timeout__highlighted" },
                [_vm._v(_vm._s(_vm.$t("Account.SelfExclusion.PinMessage")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "timeout-period-info" }, [
                _vm._v(_vm._s(_vm.$t("Account.Timeout.Desc.Three")))
              ])
            ]),
            _vm._v(" "),
            _vm.expiryDate
              ? _c("div", { staticClass: "timeout__excluded-info" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("Account.Timeout.Current")) +
                      " " +
                      _vm._s(
                        _vm._f("moment")(
                          _vm.expiryDate,
                          _vm.dateFormats.longDate
                        )
                      ) +
                      _vm._s(", ") +
                      " " +
                      _vm._s(
                        _vm._f("moment")(
                          _vm.expiryDate,
                          _vm.dateFormats.longTime
                        )
                      )
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "ctsform" }, [
                _c(
                  "div",
                  {
                    staticClass: "control-block",
                    class: { filled: _vm.timeoutDuration }
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.timeoutDuration,
                            expression: "timeoutDuration"
                          }
                        ],
                        staticClass: "input-field",
                        attrs: { id: "timeout-duration", autocomplete: "off" },
                        on: {
                          click: function($event) {
                            _vm.error = false
                          },
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.timeoutDuration = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          {
                            attrs: {
                              id: "timeout-disabled",
                              value: "",
                              disabled: ""
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Account.Timeout.Select")))]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.timeoutOptions, function(option, i) {
                          return _c(
                            "option",
                            { key: i, domProps: { value: option.value } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.Timeout.Duration." + option.label
                                  )
                                )
                              )
                            ]
                          )
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.$t("Account.Timeout.Duration"))),
                      _c("span", { staticClass: "control-label-required" }, [
                        _vm._v(" *")
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "control-block hint" }, [
                  _vm._v(
                    _vm._s(_vm.$t("Account.Timeout.Duration.PleaseSelect"))
                  )
                ]),
                _vm._v(" "),
                _vm.error
                  ? _c("div", { staticClass: "timeout__error" }, [
                      _vm._v(_vm._s(_vm.$t("Account.Timeout.Error")))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "timeout__buttons" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "primary-btn",
                        attrs: {
                          color: "success",
                          "x-large": "",
                          disabled: !_vm.timeoutDuration
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.confirmDialog = true
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("Statement.dialog.Apply")))
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "content-class": "acc-close-conf" },
          model: {
            value: _vm.confirmDialog,
            callback: function($$v) {
              _vm.confirmDialog = $$v
            },
            expression: "confirmDialog"
          }
        },
        [
          _c("div", { staticClass: "acc-close-confirmation" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("Account.CloseAccount.Dialog.Title")))
            ])
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { xs6: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { id: "btn_cancelAccount" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.confirmDialog = false
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("Account.Cancel")))])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { id: "btn_closeAccount" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.setPlayerProtection()
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("Account.Yes")))])]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9873be2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9873be2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Exclusions/V3RI/TimeoutV3.vue
// module id = null
// module chunks = 